import type { AppFeatures } from '../../../../layers/core/app/types/configurationFlags';
import type { PersonalFeatures } from '../../../../layers/personal/app/types/configurationFlags';

/** Override Veloair's default configuration flags */
export const CONFIGURATION_FLAGS: Partial<AppFeatures & PersonalFeatures> = {
  planFinder: false,
  planComparison: false,
  payments: true,
  addons: false,
  externalRegistrationData: false,
  feedback: true,
  outstandingBalance: false,
  multiBeneficiary: false,
  connectingFlights: false,
  oneTimePurchaseAncillaries: false,
  quotaBreakdown: false,
  receipts: true,
  aggregatedAvailabilities: {
    searchAnywhere: false,
    customGroups: false,
    dateCarouselPreFill: false,
    optionalSearchDates: false,
  },
};
